/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Successful triggering-task resolution after required work is achieved.
 */
export type EmployeeExecutionCompleteTriggeringTaskResolution = {
    /**
     * Stable resolution discriminator.
     */
    kind: EmployeeExecutionCompleteTriggeringTaskResolution.kind;
};
export namespace EmployeeExecutionCompleteTriggeringTaskResolution {
    /**
     * Stable resolution discriminator.
     */
    export enum kind {
        COMPLETE_AFTER_SUCCESS = 'complete-after-success',
    }
}

